import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { ContentCopyOutlined, LinkOutlined } from '@mui/icons-material';
import { useTranslations } from '@/i18n/use-translations';

type AgentPoolPlayerCellProps = {
  name: string;
  playerId: string;
  pairTooltip: string;
  showPair: boolean;
  onCopy: () => void;
  onPair: () => void;
};

export default function AgentPoolPlayerCell({
  name,
  playerId,
  pairTooltip,
  showPair,
  onCopy,
  onPair,
}: AgentPoolPlayerCellProps) {
  const t = useTranslations();
  const copyLabel = t('common.copyPlayerId', undefined, 'Copy player ID');

  return (
    <>
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {name}
      </Typography>
      <Stack direction="row" alignItems="center" spacing={0.25}>
        <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
          {playerId}
        </Typography>
        <Tooltip title={copyLabel}>
          <IconButton size="small" onClick={onCopy} aria-label={copyLabel}>
            <ContentCopyOutlined fontSize="inherit" />
          </IconButton>
        </Tooltip>
        {showPair && (
          <Tooltip title={pairTooltip}>
            <IconButton size="small" onClick={onPair} aria-label={pairTooltip}>
              <LinkOutlined fontSize="inherit" />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
    </>
  );
}
